import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
export function useIsHeaderSticky() {
  var route = useRoute();
  var stickyRoutes = ['index', 'legacy-Basic', 'legay-GenericCategory', 'products-slug', 'pages-slug', 'recipes-slug', 'search-term'];
  var isHeaderSticky = computed(function () {
    return !!stickyRoutes.find(function (r) {
      var _route$name;
      return route === null || route === void 0 ? void 0 : (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.startsWith("".concat(r, "___"));
    });
  });
  return {
    isHeaderSticky: isHeaderSticky
  };
}